import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="-0.5"
        y="0.5"
        width="8.6"
        height="9"
        rx="0.5"
        transform="matrix(-1 0 0 1 12 3)"
        stroke="#191919"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.96014 10.5C1.42994 10.5 1.00014 10.0523 1.00014 9.5V2C1.00014 1.44772 1.42994 1 1.96014 1H8.68014C9.21033 1 9.64014 1.44772 9.64014 2"
        stroke="#191919"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default Icon;
